import { expressionDefinitionApiV2, miCoverageApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const MI_COVERAGE_ACTION_TYPE = createNamedActions('miCoverage', {
  GET_CRITERIA: 'GET_CRITERIA',
  ADD_CRITERIA: 'ADD_CRITERIA',
  EDIT_CRITERIA: 'EDIT_CRITERIA',
  DELETE_CRITERIA: 'DELETE_CRITERIA',
  GET_SCHEMA: 'GET_SCHEMA',
});

const criteria = new schema.Entity('data', {}, { idAttribute: 'criteriaId' });

export const getMiCoverageCriteriaAction = catchAsyncActionError(
  ({ snapshotId } = {}) =>
    async dispatch => {
      const { data } = await miCoverageApi.getCriteria({ snapshotId });

      return dispatch({
        type: MI_COVERAGE_ACTION_TYPE.GET_CRITERIA,
        payload: normalize(data, [criteria]).entities.data,
      });
    },
);

export const addMiCoverageCriteriaAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await miCoverageApi.createCriteria(body);

  return dispatch({
    type: MI_COVERAGE_ACTION_TYPE.ADD_CRITERIA,
    payload: data,
  });
});

export const editMiCoverageCriteriaAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await miCoverageApi.editCriteria(body);

  return dispatch({
    type: MI_COVERAGE_ACTION_TYPE.EDIT_CRITERIA,
    payload: data,
  });
});

export const deleteMiCoverageCriteriaAction = catchAsyncActionError(
  ({ criteriaId }) =>
    async dispatch => {
      await miCoverageApi.deleteCriteria({ criteriaId });

      return dispatch({
        type: MI_COVERAGE_ACTION_TYPE.DELETE_CRITERIA,
        meta: { criteriaId },
      });
    },
);

export const getMiCoverageSchemaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await expressionDefinitionApiV2.getMiCoverageExpressionDefinition();

  return dispatch({
    type: MI_COVERAGE_ACTION_TYPE.GET_SCHEMA,
    payload: data,
  });
});
